import { queryUtils } from 'aem-libs-react-ts/src/utils/queryUtils'

import { InvestorTypeValue } from 'aem-libs-regular-investment/src/services/types'

import { IInputAmountValues, IInputSavingsValues, IStaticParams } from './model'
import { IQueryParams } from './model/IQueryParams'
import { parseInvestmentTypeFromString, validateMinMaxNumberValue } from './utils/investmentUtils'
import { CalcType } from './model/enums'

const getNumberValue = (value: number, min: number, max: number, defaultValue: number) => {
  if (value) {
    return validateMinMaxNumberValue(value, min, max)
  }

  return defaultValue
}

export const getInitData = (
  amountCalc: IStaticParams['amountCalc'],
  savingsCalc: IStaticParams['savingsCalc'],
  queryParams: IQueryParams,
  tab: CalcType
) => {
  let type: InvestorTypeValue
  let duration: number
  let amount: number

  if (queryParams.type) {
    type = parseInvestmentTypeFromString(queryParams.type)
  }

  if (queryParams.duration) {
    duration = queryUtils.parseQueryNumberParam(queryParams, 'duration')
  }

  if (queryParams.amount) {
    amount = queryUtils.parseQueryNumberParam(queryParams, 'amount')
  }

  const amountValues: IInputAmountValues = {
    investorType: type && tab === CalcType.Amount ? type : amountCalc.defaultInvestorType,
    duration:
      tab === CalcType.Amount
        ? getNumberValue(duration, amountCalc.minDuration, amountCalc.maxDuration, amountCalc.defaultDuration)
        : amountCalc.defaultDuration,
    amount:
      tab === CalcType.Amount
        ? getNumberValue(amount, amountCalc.minAmount, amountCalc.maxAmount, amountCalc.defaultAmount)
        : amountCalc.defaultAmount,
    deposit: amountCalc.defaultDeposit
  }

  const savingsValues: IInputSavingsValues = {
    investorType: type && tab === CalcType.Savings ? type : savingsCalc.defaultInvestorType,
    duration:
      tab === CalcType.Savings
        ? getNumberValue(duration, savingsCalc.minDuration, savingsCalc.maxDuration, savingsCalc.defaultDuration)
        : savingsCalc.defaultDuration,
    amount:
      tab === CalcType.Savings
        ? getNumberValue(amount, savingsCalc.minAmount, savingsCalc.maxAmount, savingsCalc.defaultAmount)
        : savingsCalc.defaultAmount
  }

  return { amountValues, savingsValues }
}
